import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import React from 'react';
import { Modal, Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { MultiSelect } from "react-multi-select-component";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationListStandalone, PaginationProvider } from 'react-bootstrap-table2-paginator';
import '../../App.css';
import { Constants } from "../../constants";
import SiteMenu from "../menu";

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}

function currencyFormat(num) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
class UserManager extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            account: props.location.state.account,
            page: 1,
            data: [],
            totalSize: 0,
            sizePerPage: 10,
            searchAccount: '',
            searchFirstname: '',
            searchLastname: '',
            searchEmail: '',
            accounts: [],
            selectedAccounts: [],
            selectedRecord: {},
            filterEntityType: 'Boland',
            loading: false,
            showModal: false,
            emptyText: 'No open Boland invoices.',
            rowID: -1

        };

        this.handlePaySelected = this.handlePaySelected.bind(this);

        this.handleSelect = this.handleSelect.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleRoleChange = this.handleRoleChange.bind(this);
        this.handleRequestDisable = this.handleRequestDisable.bind(this);
        this.handleClearSearch = this.handleClearSearch.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.showButton = this.showButton.bind(this);
        this.loadingSpinner = this.loadingSpinner.bind(this);
        this.selectAccounts = this.selectAccounts.bind(this);
        this.getAccounts = this.getAccounts.bind(this);

        this.handleDownloadSelected = this.handleDownloadSelected.bind(this);


        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.setEnableButtonAfterLoading = this.setEnableButtonAfterLoading.bind(this);


        this.tableRef = React.createRef();
        this.accountText = React.createRef();
        this.firstnameText = React.createRef();
        this.lastnameText = React.createRef();
        this.emailText = React.createRef();
        this.confirmModal = React.createRef();
    }

    componentDidMount() {
        this.handleTableChange("None", this.state);
        this.getAccounts();
    }
    setEnableButtonAfterLoading() {
        for (var idx = 0; idx < this.state.data.length; idx++) {
            //(document.getElementById('btnEnable_' + idx).innerText + ':' + idx + ':' + this.state.data[idx].IsLockedOut);// = 'blue';
           if (this.state.data[idx].IsLockedOut) {
                document.getElementById('btnEnable_' + idx).style.backgroundColor = 'rgb(0,151,58)';  // green
                document.getElementById('btnEnable_' + idx).innerText = 'Enable';
            }
            else {
                document.getElementById('btnEnable_' + idx).style.backgroundColor = 'rgb(239,65,57)'; //red
                document.getElementById('btnEnable_' + idx).innerText = 'Disable';
            }
        }
    }

    getAccounts() {


        axios.get(`${Constants.apiURL}/api/Identity/GetAccounts`, {
            params: {
                username: this.state.user.username
            }
        }).then(response => {
            if (response.data) {
                let accounts = response.data.map(function (acc) {
                    return {
                        label: acc.accountID + " | " + acc.accountName,
                        value: acc.accountID
                    };
                });

                this.setState(() => ({
                    accounts: accounts
                }));
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    loadingSpinner() {
        if (this.state.loading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'No records.';
        }
    };

    handleFilterChange(event) {
        let input = {};
        input[event.target.name] = event.target.value;
        this.setState(input);
        console.log('here');
    }
    handleClear(event) {
        event.preventDefault();
        if (this.state.user.isInternal) {
            this.accountText.current.value = '';
        }
        this.firstnameText.current.value = '';
        this.lastnameText.current.value = '';
        this.emailText.current.value = '';
        this.setState({
            searchAccount: '',
            searchFirstname: '',
            searchLastname: '',
            searchEmail: '',
            selectedAccounts:[]
        }, () => { this.handleTableChange('', this.state); });
    }

    handleClearSearch(event) {
        event.preventDefault();
        console.log('here');
    }

    handleSearch(event) {
        event.preventDefault();
        this.state.page = 1;
        this.handleTableChange("None", this.state);
    }

    handleSearchChange(event) {
    }

    handleSelect = (row, isSelect) => {
    }

    handleSelectAll = (isSelect, rows) => {
    }

    handlePaySelected(event) {
    }

    handleRoleChange(event, val) {
        let index = this.state.data.findIndex(e => e.AccountID == event.target.getAttribute('accountid') && e.Username == event.target.getAttribute('user'));
        let x = this.state.data;
        x[index].NormalizedRoleName = event.target.value;
        this.setState({ data: x });

        if (event.target.value == 'remove') {
            let x = {};
            x.username = event.target.getAttribute('user');
            x.accountID = event.target.getAttribute('accountid');
            this.setState({ showModal: true, selectedRecord:x });
            return;
        }


        axios.post(`${Constants.apiURL}/api/Identity/UpdateUserRole`, null, {
            params: {
                username: event.target.getAttribute('user'),
                account: event.target.getAttribute('accountid'),
                rolename: event.target.value
            }
        }).then(response => {
            this.setState({ showModal: false });
            this.handleTableChange('', this.state);
            alert('Role updated');
        }).catch((response) => {
            // ? Show to user that request is failed
            alert('Failed to update role');
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    handleRequestDisable(event) {

        if (this.state.user.isInternal) {
            var rId = event.target.getAttribute('rowID');
            var iRID = parseInt(rId);
            //alert(this.state.data[iRID].Username + ':' + iRID);
            axios.post(`${Constants.apiURL}/api/Identity/ToggleLockout`, null, {
                params: {
                    username: this.state.data[iRID].Username //event.target.getAttribute('user')
                }
            }).then(response => {
                this.handleTableChange('', this.state);
            }).catch((response) => {
                // ? Show to user that request is failed
                alert('Failed to update role');
                this.setState({ errors: [response] })
                this.setState({ loading: false });
                console.log('request failed', response)
            });
        }
        else {

            axios.post(`${Constants.apiURL}/api/Request/RequestDisableUser`, null, {
                params: {
                    requestorUsername: this.state.user.username,
                    userToDisable: event.target.getAttribute('user'),
                    accountID: event.target.getAttribute('accountID'),
                    accountName: event.target.getAttribute('accountName')
                }
            }).then(response => {
                if (response.data && response.data == true) {
                    alert('Disable request submitted to the Boland team.');
                }
                else {
                    alert('Failed to send request. Please email us directly at clientportal@boland.com if this issue persists.');
                }
            }).catch((response) => {
                // ? Show to user that request is failed
                alert('Failed to send request. Please email us directly at clientportal@boland.com if this issue persists.');
                this.setState({ errors: [response] })
                this.setState({ loading: false });
                console.log('request failed', response)
            });
        }
    }

    handleTableChange(type, { page, sizePerPage, sortField, sortOrder }) {
        this.setState({ loading: true }
            , function () {
                axios.get(`${Constants.apiURL}/api/Identity/GetUsers___`, {
                    params: {
                        username: this.state.user.username,
                        _selectedAccounts: this.state.accountSearchString,
                        _account: this.state.searchAccount.trim(),
                        _first: this.state.searchFirstname.trim(),
                        _last: this.state.searchLastname.trim(),
                        _email: this.state.searchEmail.trim(),
                        page: (page ? page - 1 : 0),
                        pageSize: sizePerPage,
                        sortOrder: sortOrder,
                        sortBy: sortField
                    }
                }).then(response => {
                    console.log(response);
                    if (response.data) {

                        //state.bdata = JSON.parse(response.data.data);
                        //state.btotalSize = response.data.rowcount;
                        this.setState(() => ({
                            page: page,
                            sizePerPage: sizePerPage,
                            sortField: sortField,
                            sortOrder: sortOrder,
                            data: JSON.parse(response.data.data),
                            totalSize: response.data.rowcount,
                            loading: false
                        }));
                        this.setEnableButtonAfterLoading();
                    }
                }).catch((response) => {
                    // ? Show to user that request is failed
                    this.setState({ errors: [response] })
                    this.setState({ loading: false });
                    console.log('request failed', response)
                });
            }
        );
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.handleDownloadSelected}>
                Download Selected
            </Button>
        }
    }

    handleClose(event) {
        console.log(event);
        if (event && event.target.name == "confirm") {
            axios.post(`${Constants.apiURL}/api/Identity/RemoveUserFromAccount`, null, {
                params: {
                    username: this.state.selectedRecord.username,
                    account: this.state.selectedRecord.accountID
                }
            }).then(response => {
                this.setState({ showModal: false, selectedRecord: {} },
                    function () {
                        alert("Success!");
                        this.handleTableChange('', this.state);
                    });
            }).catch((response) => {
                // ? Show to user that request is failed
                this.setState({ errors: [response] })
                this.setState({ loading: false });
                console.log('request failed', response)
                alert("Failed to remove account");
            });
        }
        else {
            this.setState({
                showModal: false
            });
        }
    }

    selectAccounts(selected) {
        let selectedAccountsString = selected.map((item) => {
            return item.value
        }).join(',');
        this.setState({
            selectedAccounts: selected,
            accountSearchString: selectedAccountsString
        }, () => this.handleTableChange("search", this.state));
    }

    handleDownloadSelected(event) {
    }

    render() {
        const { totalSize, page, sizePerPage, data, emptyText, accounts, selectedAccounts, showModal } = this.state;
        const hideSearchAccount = this.state.user.isInternal;

        const accountAdminMessaging = 'Below is a list of users on your admin accounts. You may update/remove account access, or request to fully disable a user who you believe should not have access to the Boland portal.';
        const internalUserMessaging = 'Below is a list of all Boland portal users. You may update/remove account access, or fully disable a user who should not have access to the Boland portal.';

        const customValueRenderer = (selected, _options) => {
            return selected.length
                ? selected.map(({ label }) => label + ", ").join('').replace(/, $/, '')
                : "My Admin Accounts...";
        };
        var o = document.getElementById('user_manager_table');
        if (o != null && o.rows.length != 2 && o.rows.length != 11)
            this.rowID = o.rows.length - 2;
        else
            this.rowID = -1;
        const columns = [
            {
                dataField: 'Email',
                text: 'User Email Address',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', width:'300px' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'Firstname',
                text: 'First Name',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '180px', textAlign: 'center' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'Lastname',
                text: 'Last Name',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '180px', textAlign: 'center' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'AccountID',
                text: 'Linked Account Number',
                align: 'center',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '150px', textAlign: 'center' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'CustomerName',
                text: 'Linked Account Name',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'NormalizedRoleName',
                text: 'Update/Remove Account Access',
                align: 'center',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '205px', textAlign: 'center' };
                },
                style: {
                    verticalAlign: 'middle'
                },
                formatter: (cell, row) => {
                    console.log(row);

                    return (
                        <Form.Select onChange={this.handleRoleChange} accountid={row.AccountID} user={row.Username} value={cell} size="md" name="filterType">
                            <option value="ORD_ACCOUNTADMIN">Account Admin</option>
                            <option value="ORD_FULLACCESS">Standard + Finance</option>
                            <option value="ORD_WORKONLY">Standard User</option>
                            <option value="remove">Remove from account</option>
                        </Form.Select>);
                }
            },
            {
                dataField: '',
                text: 'Disable User',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { width: '140px', textAlign: 'center' };
                },
                style: {
                    verticalAlign: 'middle'
                },
                formatter: (cell, row) => {
                    this.rowID++;
                   let curRow = this.state.data[this.rowID];
                    return (
                        <Button id={'btnEnable_' + this.rowID} rowID={this.rowID} style={!this.state.user.isInternal || !curRow.IsLockedOut ? { backgroundColor: '#EF4139' } : { backgroundColor: '#00973A' }}
                            user={curRow.Username} accountID={curRow.AccountID} accountName={curRow.CustomerName} onClick={this.handleRequestDisable}>
                            {!this.state.user.isInternal ? 'Request disable' : !curRow.IsLockedOut ? 'Disable' : 'Enable'}
                        </Button>);
                }
            },
            {
                dataField: 'IsLockedOut',
                text: 'User Disabled?',
                sort: true,
                align: 'center',
                hidden: !this.state.user.isInternal,
                headerStyle: (colum, colIndex) => {
                    return { width: '110px', textAlign: 'center' };
                },
                style: {
                    verticalAlign: 'middle'
                },
                formatter: function (cell, row) {
                    return <Form.Check type='checkbox' disabled={true} checked={cell} />
                }
            }
        ];
        const defaultSorted = [{
            dataField: 'AccountID',
            order: 'asc'
        }];
        const pagination = {
            custom: true,
            totalSize: totalSize,
            page: page,
            sizePerPage: sizePerPage,
            hideSizePerPage: true
        };

        return (
            <div class='user_manager'>
                <Modal ref={this.confirmModal} show={showModal} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Confirm removal of selected user from account.</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" name="cancel" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" name="confirm" onClick={this.handleClose}>
                            Confirm
                        </Button>
                    </Modal.Footer>
                </Modal>
                <SiteMenu user={this.state.user} currentPage='userManager' />
                <Form className="mb-3" submit={this.handleSearch}>
                    <Row style={{paddingLeft:'12px'}}>
                        <Form.Label style={{
                            paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B', paddingTop: '10px'}}>
                            USER ACCOUNT MANAGER</Form.Label>
                        <Form.Label style={{ paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', paddingTop: '0px', fontStyle: 'italic', fontSize: '15px' }}>
                            {this.state.user.isInternal ? internalUserMessaging : accountAdminMessaging}</Form.Label>
                    </Row>
                    <Form.Group as={Row} style={{ padding: '10px 15px 0px 15px' }} className="user-manager-search">
                        {!hideSearchAccount &&
                            <Col md="auto" style={{ paddingLeft: '7px' }}>
                                <MultiSelect
                                    style={{ width: '300px' }}
                                    className="multiselect sm"
                                    options={accounts}
                                    onChange={this.selectAccounts}
                                    labelledBy="Select"
                                    value={selectedAccounts}
                                    valueRenderer={customValueRenderer}
                                    hasSelectAll={false}
                                />
                            </Col>
                        }
                        <Col width='100%' />
                        {hideSearchAccount &&
                            <Col md="auto">
                                <Form.Control type="input" size="sm" value={this.state.searchAccount} style={{ width: '200px' }} name="searchAccount" ref={this.accountText}
                                    onChange={this.handleFilterChange} placeholder="Search by account number..." />
                            </Col>
                        }
                        <Col md="auto" style={{ paddingLeft: 0 }}>
                            <Form.Control type="input" size="sm" value={this.state.searchFirstname} name="searchFirstname" ref={this.firstnameText}
                                onChange={this.handleFilterChange} placeholder="Search by first name..." />
                        </Col>
                        <Col md="auto" style={{ paddingLeft: 0 }}>
                            <Form.Control type="input" size="sm" value={this.state.searchLastname} name="searchLastname" ref={this.lastnameText}
                                onChange={this.handleFilterChange} placeholder="Search by last name..." />
                        </Col>
                        <Col md="auto" style={{ paddingLeft: 0 }}>
                            <Form.Control styletype="input" size="sm" value={this.state.searchEmail} name="searchEmail" ref={this.emailText}
                                onChange={this.handleFilterChange} placeholder="Search by email..." />
                        </Col>
                        <Col md="auto" style={{ paddingLeft: 0 }}>
                            <Button size="sm" style={{ width: 'auto', marginLeft: 0 }} variant="primary" type='submit' onClick={this.handleSearch}>Search</Button>
                        </Col>
                        <Col md="auto" style={{ paddingLeft: 0 }} >
                            <Button size="sm" style={{ width: 'auto', marginLeft: 0 }} variant="secondary" onClick={this.handleClear}>Clear</Button>
                        </Col>
                    </Form.Group>
                </Form>
                <div>
                    <PaginationProvider pagination={paginationFactory(pagination)}>
                        {({
                            paginationProps,
                            paginationTableProps
                        }) => (
                            <div>
                                <BootstrapTable
                                    bootstrap4
                                    remote
                                    id="user_manager_table"
                                    keyField="InvoiceKey"
                                    wrapperClasses="table-responsive user_manager_table"
                                    data={data}
                                    columns={columns}
                                    onTableChange={this.handleTableChange}
                                    totalSize={this.state.totalSize}
                                    noDataIndication={this.loadingSpinner}
                                    defaultSorted={defaultSorted}
                                    noDataIndication={this.loadingSpinner}
                                    loading={this.state.loading}
                                    //afterloading={this.setEnableButtonAfterLoading}
                                    hover
                                    striped
                                    ref={this.tableRef}
                                    {...paginationTableProps}
                                />
                                <Form.Group as={Row} controlId="bolandButtons" style={{ padding: '0px 0px 0px 0px', marginRight: 0 }}>
                                    <Col width='100%' />
                                    <Col md="auto" sm="auto" xs="auto"
                                        style={{ paddingRight: '10px' }} >
                                        <PaginationListStandalone
                                            {...paginationProps}
                                        />
                                    </Col>
                                </Form.Group>
                            </div>
                        )
                        }
                    </PaginationProvider>
                </div>
            </div >
        );
    }
}

export default UserManager;